import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { leaveGroupChatRoom } from '~/api';
import { PAGE_ROUTE } from '~/constants';
import useToast from '~/store/useToast';
import chatRoomKey from './chatRoomKey';

const useLeaveGroupChatRoomMutation = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: leaveGroupChatRoom,
    onError: (error) => {
      console.error(error);
      showToast('error', 'cannot leave chat');
    },
    onSuccess: (response, request) => {
      const queryKey = [...chatRoomKey.all, 'group'];

      queryClient.setQueriesData({ queryKey, exact: false }, (oldData: any) => {
        if (!oldData?.pages) return oldData;

        const decrementParticipants = (chatRoom: any) =>
          chatRoom.id === request.chatroom_id
            ? {
                ...chatRoom,
                participants_num: String(
                  Math.max(0, Number(chatRoom.participants_num) - 1),
                ),
              }
            : chatRoom;

        if (oldData.pages[0]?.status === 200) {
          return {
            ...oldData,
            pages: oldData.pages.map((page: any) =>
              !page?.data
                ? page
                : {
                    ...page,
                    data: Array.isArray(page.data)
                      ? page.data.map(decrementParticipants)
                      : page.data,
                  },
            ),
          };
        }

        if (Array.isArray(oldData.pages) && oldData.pages[0]?.id) {
          return {
            ...oldData,
            pages: oldData.pages.map(decrementParticipants),
          };
        }

        return oldData;
      });

      queryClient.invalidateQueries({
        queryKey: chatRoomKey.getChatList(),
        refetchType: 'all',
      });

      navigate(PAGE_ROUTE.CHAT_LIST);
      return;
    },
  });
};

export default useLeaveGroupChatRoomMutation;
